import React from "react";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const spin = keyframes`
  0% { 
    transform: rotate(0deg); 
    box-shadow: 0 0 0 0 rgba(200, 67, 67, 0.7);
  }
  50% { 
    box-shadow: 0 0 0 10px rgba(114, 11, 54, 0.3);
  }
  100% { 
    transform: rotate(360deg); 
    box-shadow: 0 0 0 0 rgba(171, 43, 43, 0.7);
  }
`;

interface LoaderContainerProps {
  fullScreen?: boolean;
}

const LoaderContainer = styled.div<LoaderContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.fullScreen ? "100vh" : "auto")};
  width: ${(props) => (props.fullScreen ? "100vw" : "auto")};
  padding: ${(props) => (props.fullScreen ? "0" : "20px")};
`;

interface SpinnerProps {
  size: number;
  color: string;
}

const Spinner = styled.div<SpinnerProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: 3px solid rgba(74, 124, 245, 0.2);
  border-top: 3px solid ${(props) => props.color};
  border-radius: 50%;
  animation: ${spin} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: 3px solid transparent;
    border-radius: 50%;
    border-top: 3px solid ${(props) => props.color};
    opacity: 0.5;
    animation: ${spin} 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }
` as any;

const Loader = ({ size = 40, color = "#4a7cf5", fullScreen = false }) => {
  return (
    <LoaderContainer fullScreen={fullScreen}>
      <Spinner size={size} color={color} />
    </LoaderContainer>
  );
};

export default Loader;
